import { Box } from "@mui/material";
import { useParams } from "react-router-dom";

import { useScoutChatWithMocks as useScoutChat } from "../hooks/useScoutChatWithMocks";
import { ChatChrome } from "./ChatChrome";
import { NewChat } from "./NewChat";

export const ScoutChat = () => {
  const { conversationId } = useParams();
  const { messages, isSending, handleSubmit, abortMessage } = useScoutChat(conversationId);

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "center",
      }}
    >
      {messages.length === 0 ? (
        <NewChat onSubmit={handleSubmit} onAbort={abortMessage} isSending={isSending} />
      ) : (
        <ChatChrome
          messages={messages}
          onSubmit={handleSubmit}
          onAbort={abortMessage}
          isSending={isSending}
        />
      )}
    </Box>
  );
};
